/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var react_animate_height_1 = require("react-animate-height");
var IconButton_1 = require("./IconButton");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Notification.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Icon_1 = require("./Icon");
var Description_1 = require("./Description");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-notification");
var Notification = /** @class */ (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expandable: false,
            showDetail: false
        };
        _this.toggleDetail = function () {
            _this.setState({
                showDetail: !_this.state.showDetail
            });
        };
        return _this;
    }
    Notification.prototype.render = function () {
        var _a = this.props, id = _a.id, children = _a.children, className = _a.className, highlighted = _a.highlighted, date = _a.date, title = _a.title, expandable = _a.expandable, iconType = _a.iconType, props = tslib_1.__rest(_a, ["id", "children", "className", "highlighted", "date", "title", "expandable", "iconType"]);
        var showDetail = this.state.showDetail;
        return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), highlighted && moduleClassName("isHighlighted"), className) }, props),
            React.createElement("div", { className: moduleClassName("summary") },
                React.createElement(Icon_1.Icon, { type: iconType }),
                React.createElement("div", { className: moduleClassName("content") },
                    React.createElement(Description_1.Description, null,
                        React.createElement("small", null, date)),
                    React.createElement("div", { className: moduleClassName("title") }, title),
                    !expandable && children),
                expandable && (React.createElement(IconButton_1.IconButton, { TagName: "button", color: "blue", className: moduleClassName("expandButton"), type: showDetail ? "minus" : "plus", onClick: this.toggleDetail, "aria-expanded": showDetail, "aria-controls": id }))),
            expandable && (React.createElement(react_animate_height_1.default, { id: id, height: showDetail ? "auto" : 0, duration: 200 },
                React.createElement("div", { className: moduleClassName("expandedDetail") }, children)))));
    };
    Notification.propTypes = {
        id: PropTypes.string,
        highlighted: PropTypes.bool,
        date: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        className: PropTypes.string,
        expandable: PropTypes.bool,
        iconType: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired
    };
    return Notification;
}(React.Component));
exports.Notification = Notification;